<form [formGroup]="form">
    <ckeditor
        #htmlContentEditor
        [editor]="Editor"
        [config]="editorConfig"
        formControlName="htmlContent"
        [(ngModel)]="emailFooterHtmlContent"
        (ready)="editorReady($event)"
    ></ckeditor>
    <wm-control-message
        [control]="form.controls['htmlContent']"
    ></wm-control-message>
</form>
